import React, { useState, useEffect, useRef } from 'react'
// import axios from 'axios'
import TimeAgo from 'react-timeago'
import Loader from '../../common/loader'
import useOnClickOutside from '../../../hooks/use-onclick-outside'
import GET_API_KEY from '../../../utils/getApiKey'
import useIntervalHook from '../../../hooks/use-interval-hook'
import { NOTIFICATIONS } from '../../../utils/endpoint'
import { BASE_URL } from '../../../utils/environment'
import axios from '../../../services/axios'
import './styles.scss'
import { pressable } from '../../../utils/pressable'

// The bell's list in the games app (api/notifications), refreshed every minute. Reading one marks it read on the
// server it came from (it used to always call staging), and See All opens the notices page of the site the games app
// belongs to (it used to open staging from the live site). A list that can't load says so instead of loading forever.
const markAsSeen = (id) => {
    var data = JSON.stringify({
        id: id,
    })
    const headers = {
        Authorization: 'Bearer ' + GET_API_KEY(),
        'Content-Type': 'application/json',
    }

    var config = {
        method: 'post',
        url: `${BASE_URL}notification/read`,
        headers,
        data,
    }

    axios(config)
        .then(function (response) {
            console.log(JSON.stringify(response.data))
        })
        .catch(function (error) {
            console.log(error)
        })
}

const Index = ({
    show,
    handleClose,
    notificationCount,
    style,
    loginTypeFlag,
}) => {
    const [data, setData] = useState(null)
    const [failed, setFailed] = useState(false)
    // const ref = useRef();
    useEffect(() => {
        fetchNotification()
    }, [])
    useEffect(() => {
        if (data) {
            const getUnseenNotification = data.filter(
                (dt) => dt.read_at == null
            )
            notificationCount(getUnseenNotification.length)
        }
    }, [data])
    // New notifications show within a minute. (A Pusher channel used to be opened for instant updates, but the server
    // never sent on it; removed 2026-10-20 with Pusher itself.)
    useIntervalHook(() => {
        fetchNotification()
    }, 1000 * 60)
    const fetchNotification = () => {
        const API_KEY = GET_API_KEY()
        const params = {
            headers: {
                Authorization: 'Bearer ' + API_KEY,
            },
        }
        //setIsLoading(true)
        axios.get(NOTIFICATIONS, params).then(
            (response) => {
                if (response && Array.isArray(response.body)) {
                    setData(response.body)
                    setFailed(false)
                } else {
                    setFailed(true)
                }
            },
            (error) => {
                if (error.message.indexOf('401') >= 0) {
                    localStorage.clear()
                    window.location.replace(
                        process.env.REACT_APP_PAGE_BACKEND + 'login'
                    )
                    return
                }
                setFailed(true)
            }
        )
    }

    const handleNotificationClick = (id) => {
        console.log('id', id)
        if (id) {
            const copy = [...data]
            markAsSeen(id)
            const index = data.findIndex((data) => data.id === id)
            copy[index].read_at = '123'
            setData(copy)
        } else {
            window.open(`${process.env.REACT_APP_PAGE_BACKEND || 'https://app.smartyearslearning.com/'}notices`, '_blank')
        }
    }

    return (
        <div
            style={style}
            onMouseDown={(e) => e.stopPropagation()}
            className={`notifications-container ${show ? 'fadeIn' : 'fadeOut'}`}
        >
            <span className="corner"></span>
            <div className="notification-in">
                {data && data.length === 0 ? (
                    <p className="notification-empty">
                        <i className="fas fa-check-circle" aria-hidden="true" /> You're all caught up.
                    </p>
                ) : !data && failed ? (
                    <p className="notification-empty">The notifications couldn't load. They'll try again in a minute.</p>
                ) : data ? (
                    data.map((dt) => (
                        <div
                            className="notification"
                            key={dt.id}
                            onClick={() => handleNotificationClick(dt.id)}
                            {...pressable(() => handleNotificationClick(dt.id))}
                        >
                            <div
                                className={`dot ${
                                    dt.read_at ? '' : 'not-seen'
                                }`}
                            ></div>
                            <div className="notification-info">
                                <h3
                                    dangerouslySetInnerHTML={{
                                        __html: dt.data,
                                    }}
                                    onClick={(e) => e.stopPropagation()}
                                ></h3>
                                <div className="notification-timer">
                                    <TimeAgo date={dt.created_at} />
                                </div>
                            </div>
                        </div>
                    ))
                ) : (
                    <Loader />
                )}
            </div>
            {loginTypeFlag && (
                <a
                    className="btn-view-all"
                    onClick={() => handleNotificationClick(null)}
                >
                    See All Notifications
                </a>
            )}
        </div>
    )
}

export default Index
